import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { backAddressBoxStyle, backAddressTextStyle, backBodyOuterBoxStyle, backCardStyle, backColorStripStyle, backContactNumberinnerBoxStyle, backContactNumberOuterBoxStyle, backContactNumberTextStyle, backSlogansBoxStyle, backSlogansStyle, backSlogansTextStyle, backWORKlogoBoxStyle, backWORKlogoStyle, bodyBoxStyle, cardOuterBoxStyle, cardOverlayStyle, cardStyle, detailsBoxStyle, detailsTableRowStyle, headerBoxStyle, headingStyle, imageStyle, logoStyle, noteTextStyle, photoBoxStyle, photoStyle, tableStyle, titleStyle } from './memcard-css'
import { green, headingBlue, maroon, orange, red, skyBlue } from '../../assets/colors'
import { hindiSlogansFP, hindiSlogansSP, slogansData } from '../../utils/constants'
import { getWORKerImage } from '../../backend/backendApis'
import HttpService from '../../backend/requestApis'
import { buttonStyle } from '../formStyle'
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useNavigate } from 'react-router-dom'
import Loader from '../Loader'

const Memcard = (props) => {
    // console.log("props: ", props)

    const isMobile = window.innerWidth <= 768
    const navigate = useNavigate()

    const pdfRef = useRef()
    const pdfRef1 = useRef()
    const pdfRef2 = useRef()

    const [imageUrl, setImageUrl] = useState(null)
    const [errorMsg, setErrorMsg] = useState(null)
    const [loader, setLoader] = useState(false)

    const handleDownloadPDF = async () => {
        try{
            const card = pdfRef.current

            const canvasCard = await html2canvas(card, {
                scale: 3,
                useCORS: true
            })
          
              const imgData = canvasCard.toDataURL('image/png')
              const pdf = new jsPDF('p', 'mm', 'a4');
          
              const pageWidth = pdf.internal.pageSize.getWidth();
              const pageHeight = pdf.internal.pageSize.getHeight();
          
              const imgProps = pdf.getImageProperties(imgData)
              const pdfWidth = pageWidth-4;
              const pdfHeight = (imgProps.height * (pdfWidth - 6)) / imgProps.width;
          
              isMobile ? 
              pdf.addImage(imgData, 'PNG', 60, 8,(pdfWidth/2) - 5, pdfHeight/2 + 1)
              :
              pdf.addImage(imgData, 'PNG', 6, 8,pdfWidth-13, pdfHeight-1)
              pdf.save(`${props.name}_Membership_Card.pdf`);
        } catch(err){
            console.log('Error in downloading pdf: ', err)
        }
    }

    useEffect(() => {
        try{
            if(props.memcardDialogStatus && props.photoStatus === 'accepted'){
                setLoader(true)
                let options = {
                    url: getWORKerImage,
                    method:'GET',
                    params: {
                        contactNumber: props?.contactNumber ? props?.contactNumber : localStorage.getItem('contact')
                    },
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
                    }
                }
                HttpService(options).then(resp => {
                    console.log("url: ", resp?.data?.data?.data?.url)
                    setImageUrl(resp?.data?.data?.data?.url)
                    setLoader(false)
                }).catch(err => {
                    console.log(" Error in fetching WORKers Image.")
                    setLoader(false)
                    setErrorMsg('Error in Fetching the Photo. Please Contact Support.')
                } )
                }
            } catch(err){
                if (err?.status === 403) {
                localStorage.clear();
                setLoader(false)
                // setLoadingTableData(false);
                navigate("/signUp");
            } else {
                console.log("Err:", err)
                setErrorMsg('Error in Fetching the Photo. Please Contact Support.')
                setLoader(false)
                // setLoadingTableData(false);
                }
            }
    }, [props.memcardDialogStatus])

  return (
    <>
    <Dialog maxWidth= 'sm' fullWidth open={props.memcardDialogStatus} onClose={() => props.updatememCardDialogStatus()}>
        <DialogTitle
            sx={{height: "1.8rem", padding: "0.4rem 0rem 0.4rem 1rem"  }}
            style={titleStyle}
        >
            Membership Card

        </DialogTitle>
        <DialogContent>
            <>
                {loader && <Loader></Loader>}
                <Box ref={pdfRef} style={cardOuterBoxStyle} >
                    <Grid container columnGap={2} rowGap={5}>
                        <Grid item xs={12} sm= {5.75} >
                            <Box ref={pdfRef1} style={{...cardStyle}} >
                                <Box style={headerBoxStyle}>
                                    <img style={logoStyle} src={require("../../assets/images/WORK_logo.png")}>
                                    </img>
                                    <Typography style={headingStyle}>World Organisation of Religions & Knowledge
                                    </Typography>
                                </Box>
                                <Box style={bodyBoxStyle}>
                                    <Box style={detailsBoxStyle}>
                                        <table style={tableStyle} >
                                            <tbody>
                                                <tr style={detailsTableRowStyle}>
                                                    <td>Name</td>
                                                    <td>: {props.name}</td>
                                                </tr>
                                                <tr style={detailsTableRowStyle}>
                                                    <td>Obligation</td>
                                                    <td>: {props.obligation}</td>
                                                </tr>
                                                <tr style={detailsTableRowStyle}>
                                                    <td>ID No.</td>
                                                    <td>: {props.chapterCode}{props.id}</td>
                                                </tr>
                                                <tr style={detailsTableRowStyle}>
                                                    <td>Valid Upto</td>
                                                    <td>: 31-12-2026</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </Box>
                                    <Box style={photoBoxStyle}>
                                        
                                        <img 
                                            src={
                                                imageUrl && props.photoStatus === 'accepted' ? imageUrl : 
                                                require('../../assets/images/leader.png')}
                                            style={photoStyle}
                                                ></img>

                                    </Box>

                                </Box>
                                

                            </Box>
                        </Grid>
                        <Grid item xs={12} sm= {5.75} >
                            <Box ref={pdfRef2} style={{...backCardStyle}} >
                                <img style={imageStyle} src={require('../../assets/images/memCardBS.png')}></img>
                                {/* <Box style={backAddressBoxStyle}>
                                    <Typography style={backAddressTextStyle}> H.O. at Shams Naved Hall, Rampur U.P.244901 INDIA</Typography>
                                </Box> */}
                                
                                {/* <Grid container spacing={0}>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: green}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: headingBlue}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: orange}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: skyBlue}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: red}}></Box>
                                    </Grid>

                                </Grid> */}
                                {/* <Box style={backBodyOuterBoxStyle}>
                                    <Box style={backWORKlogoBoxStyle}>
                                        <img src={require('../../assets/images/WORK_logo.png')}
                                            style={backWORKlogoStyle}
                                        ></img>
                                    </Box>
                                    <Box style={backSlogansBoxStyle}>
                                        <Typography style={backSlogansTextStyle} sx={{ textAlign: 'center' }}>{slogansData[0]}</Typography>
                                        <Typography style={backSlogansTextStyle} sx={{ textAlign: 'center' }}>{slogansData[1]}</Typography>
                                        <Typography style={backSlogansTextStyle} sx= {{textAlign:'center'}}>{slogansData[2]}</Typography>
                                        <Typography style={backSlogansTextStyle} sx= {{textAlign:'center'}}>{slogansData[3]}</Typography>
                                        <Typography style={backSlogansTextStyle} sx= {{textAlign:'center'}}>{slogansData[4]}</Typography>
                                    </Box>
                                    <Box>
                                    <img src={require('../../assets/images/WORK_logo.png')}
                                            style={backWORKlogoStyle}
                                        ></img>
                                    </Box>

                                </Box> */}

                                {/* <Box style={backBodyOuterBoxStyle}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={3.3} sm={3.3}>
                                        <img src={require('../../assets/images/WORK_logo.png')}
                                                style={backWORKlogoStyle}
                                            ></img>
                                        </Grid>
                                        <Grid item xs={2.6} sm={2.6}>
                                            {hindiSlogansFP.map(slogan => {
                                                return (
                                                    <Typography style={{...backSlogansTextStyle, textAlign: 'left'}}>{slogan}</Typography>
                                                )
                                            })}

                                        </Grid>
                                        <Grid item xs={0.1} sm={0.1}>
                                            {hindiSlogansFP.map(slogan => {
                                                return (
                                                    <Typography style={backSlogansTextStyle}>-</Typography>
                                                )
                                            })}
                                        </Grid>
                                        <Grid item xs={2.6} sm={2.6}>
                                            {hindiSlogansSP.map(slogan => {
                                                return (
                                                    <Typography style={{...backSlogansTextStyle, textAlign: 'right'}}>{slogan}</Typography>
                                                )
                                            })}

                                        </Grid>
                                        <Grid item xs={3.3} sm={3.3}>
                                        <img src={require('../../assets/images/WORK_logo.png')}
                                                style={backWORKlogoStyle}
                                            ></img>
                                        </Grid>

                                    </Grid>
                                </Box> */}

                                {/* <Box>
                                    <Typography style= {backSlogansTextStyle}>{slogansData[5]}</Typography>
                                </Box> */}
                                {/* <Box style={backContactNumberOuterBoxStyle}>
                                    <Box style={backContactNumberinnerBoxStyle}>
                                        <Typography style={backContactNumberTextStyle}>+91 5952327600</Typography>
                                    </Box>
                                    <Box style={backContactNumberinnerBoxStyle}>
                                        <Typography style={backContactNumberTextStyle}>+91 9368009628</Typography>
                                    </Box>
                                </Box> */}

                                {/* <Grid container spacing={0}>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: green}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: headingBlue}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: orange}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: skyBlue}}></Box>
                                    </Grid>
                                    <Grid item xs={2.4} sm={2.4}>
                                        <Box style={{...backColorStripStyle, backgroundColor: red}}></Box>
                                    </Grid>

                                </Grid> */}

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    {props.photoStatus === 'InProgress' &&
                        <Typography style={noteTextStyle}>Note: Your Photograph is under verification. Once verified it will be updated on Membership card.</Typography>
                    }
                </Box>
                <Box style={{display:'flex', justifyContent: 'center'}}>
                    <Button style={{...buttonStyle, marginBottom: '0rem',fontSize: '0.8rem', padding: '0.2rem 0.4rem 0.2rem 0.4rem'}}
                    onClick={() => handleDownloadPDF()}
                    >Download</Button>
                    {/* <PDFDownloadLink document={<handleDownloadPDF></handleDownloadPDF>} fileName={`${props.name}_Membership_Card`}>
                    Download
                    </PDFDownloadLink> */}
                </Box>
                <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1rem 0.5rem 0.5rem 0.5rem'}}>
                    <Typography style={{color: maroon, fontSize: '1rem'}}> 
                        {errorMsg}
                    </Typography>
                </Box>
            </>

        </DialogContent>

    </Dialog>
    </>
  )
}

export default Memcard
